import React from 'react';
import { useTranslation } from 'react-i18next';
import './HeroSection.scss';

const HeroSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            {t('heroTitle')}
          </h1>
          <p className="hero-description">
            {t('heroDescription')}
          </p>
          <div className="hero-buttons">
            <button className="cta-button primary">
              {t('startButton')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
